import { adminServerInstance } from "../axios/instances";

export function getOrderCountBySubBatch(subBatch) {
    return function(dispatch) {
        return adminServerInstance.get(`/business/getordercountbysubbatch?sub_batch=${subBatch}`)
        .then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}

export function getRecentSubBatches(branch, limit) {
    return function(dispatch) {
        return adminServerInstance.get(`/workflow/getrecentsubbatches`,{
            params: {
                branch,
                limit
            }}).then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}

export function getStatesInBatch(batchNo){
    return function(dispatch) {
        return adminServerInstance.get(`/workflow/getstatesinbatch`,{
            params: {
                batch_no: batchNo
            }}).then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}

export function getBatchCountByWarehouse(batchNo){
    return function(dispatch) {
        return adminServerInstance.get(`/workflow/getbatchcountbywarehouse`,{
            params: {
                batch_no: batchNo
            }}).then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}
export function getBatchCountByPortWarehouse(batchNo){
    return function(dispatch) {
        return adminServerInstance.get(`/workflow/getbatchcountbyportarehouse`,{
            params: {
                batch_no: batchNo
            }}).then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}
export function getBatchCountOverSizeByWarehouse(batchNo){
    return function(dispatch) {
        return adminServerInstance.get(`/workflow/getbatchcountoversizebyarehouse`,{
            params: {
                batch_no: batchNo
            }}).then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}
/**
 * port transit
 * @param port:  port warehouse id,
 * @param original_batch: original batch number
 * @param is_auto: is auto or not
 * @param target_batch: target batch number
 * @type {port:  number,original_batch:string ,is_auto:number,target_batch:string}
 * @return{id:number,name:string,qty:number}
 *
 * workflow
 * @param warehouse: warehouse id,
 * @param original_batch: original batch number
 * @param is_auto: is auto or not
 * @param target_batch: target batch number
 * @type {warehouse:  number,original_batch:string ,is_auto:number,target_batch:string}
 * @return{id:number,name:string,qty:number}
 */
export function transferPackagesByWarehouseOrState(params) {
    return function (dispatch) {
        return adminServerInstance.post(`/workflow/transferpackagesbywarehouseorstate`, params)
            .then(({data}) => {
                return Promise.resolve(data.data);
            }).catch(error => {
                return Promise.reject(error);
            });
    }
}